import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-mat-chip-list',
  templateUrl: './mat-chip-list.component.html',
  styleUrls: ['./mat-chip-list.component.scss']
})
export class MatChipListComponent implements OnInit {

  @Input() searchKeyWordList: string[];
  @Output() wordToremove=new EventEmitter<string>();
  
  selectable = true;
  removeChip=true;
  removable = [false,false,true,true,true];

  constructor() { }

  ngOnInit() {
  }

  remove(word:string){
    this.wordToremove.emit(word);
  }

}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/common/mat-chip-list/mat-chip-list.component.ts